import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AiService } from '../ai.service';
import * as AiActions from './ai.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Action, Store } from '@ngrx/store';
import { selectAiModel } from './ai.selector';

@Injectable()
export class AiEffects {
  postClaudeStructured$: Observable<Action>;
  requestScenes$: Observable<Action>;
  requestObjects$: Observable<Action>;
  requestActions$: Observable<Action>;

  constructor(
    private actions$: Actions,
    private aiService: AiService,
    private store: Store,
  ) {
    // this.postClaudeStructured$ = createEffect(() =>
    //   this.actions$.pipe(
    //     ofType(AiActions.postClaudeStructured),
    //     switchMap(({ payload }) =>
    //       this.aiService.postClaudeStructured(payload).pipe(
    //         map(response => AiActions.postClaudeStructuredSuccess({ response })),
    //         catchError(error => of(AiActions.postClaudeStructuredFailure({ error: error.message || 'Unknown error' })))
    //       )
    //     )
    //   )
    // );

    this.requestScenes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(AiActions.requestScenes),
        withLatestFrom(this.store.select(selectAiModel)),
        switchMap(([{ prompt }, model]) =>
          this.aiService.requestScenes(model, prompt).pipe(
            map(response => {
              if (model === 'openai') {
                console.log('response', response);
                const { choices } = response;
                const { message } = choices[0];
                const data = message.tool_calls[0].function.arguments;
                console.log('data', data);
                const { scenes } = JSON.parse(data);
                return [model, scenes];
              } else {
                console.log('response', response);
                const { content } = response;
                const { input } = content[0];
                return [
                  model,
                  input.scenes.map(scene => ({ description: scene })),
                ] as ['openai' | 'claude', any];
              }
            }),
          ),
        ),
        switchMap(([model, scenes]) => [
          AiActions.setScenes({ model, scenes }),
          AiActions.setLoading({ loading: false }),
        ]),
        catchError(error =>
          of(
            AiActions.requestScenesFailure({
              error: error.message || 'Unknown error',
            }),
          ),
        ),
      ),
    );

    this.requestObjects$ = createEffect(() =>
      this.actions$.pipe(
        ofType(AiActions.requestObjects),
        withLatestFrom(this.store.select(selectAiModel)),
        switchMap(([{ prompt }, model]) =>
          this.aiService.requestObjects(model, prompt).pipe(
            map(response => AiActions.requestObjectsSuccess({ response })),
            catchError(error =>
              of(
                AiActions.requestObjectsFailure({
                  error: error.message || 'Unknown error',
                }),
              ),
            ),
          ),
        ),
      ),
    );

    this.requestActions$ = createEffect(() =>
      this.actions$.pipe(
        ofType(AiActions.requestActions),
        withLatestFrom(this.store.select(selectAiModel)),
        switchMap(([{ prompt }, model]) =>
          this.aiService.requestActions(model, prompt).pipe(
            map(response => AiActions.requestActionsSuccess({ response })),
            catchError(error =>
              of(
                AiActions.requestActionsFailure({
                  error: error.message || 'Unknown error',
                }),
              ),
            ),
          ),
        ),
      ),
    );
  }
}
